import React from "react";
import { Link } from "react-router-dom";
import ActionGroup from "./ActionGroup";
import { navigationLinks, studioLinks, utilityActions } from "../siteContent";

const Footer = () => {
  const footerActions = utilityActions.filter((action) => action.label !== "Instagram");

  return (
    <footer className="site-footer">
      <div className="container">
        <section className="footer-cta">
          <div>
            <p className="section-eyebrow">Lizzie Fox Colour Studio</p>
            <h2>Confidence led colour for women ready to feel like themselves again</h2>
          </div>
          <div className="footer-cta__actions">
            <ActionGroup actions={footerActions} />
            <a
              aria-label="Visit Lizzie Fox Colour Studio on Instagram"
              className="instagram-icon-link instagram-icon-link--footer"
              href={studioLinks.instagram}
              rel="noreferrer"
              target="_blank"
            >
              <img alt="" aria-hidden="true" src="/images/instagram.png" />
            </a>
          </div>
        </section>

        <div className="footer-grid">
          <div>
            <img
              alt="Lizzie Fox Colour Studio stacked logo"
              className="footer-logo"
              src="/branding/logo-stacked.svg"
            />
            <p className="footer-copy">
              Grey Blending, Colour Analysis, and low-maintenance luxury colour
              from Derby and online.
            </p>
          </div>

          <div>
            <h3>Navigation</h3>
            <div className="footer-links">
              {navigationLinks.map((link) => (
                <Link key={link.to} to={link.to}>
                  {link.label}
                </Link>
              ))}
              <Link to="/terms">Policies</Link>
            </div>
          </div>

          <div>
            <h3>Contact</h3>
            <div className="footer-links">
              <a href="mailto:lizzie@lizziefoxhair.co.uk">
                lizzie@lizziefoxhair.co.uk
              </a>
              <p>Bay Studios, 31 Moor St, Spondon, Derby DE21 7EA</p>
              <p>Online consultations and colour analysis available.</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Lizzie Fox Colour Studio. All rights reserved. Designed and built by{' '}
          <a
            href="https://foxwebservices.com/"
            target="_blank"
            rel="noreferrer"
            className="font-semibold text-[#111111] underline decoration-black/20 underline-offset-4 transition hover:decoration-black"
          >
            Fox Web Services
          </a>

          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
